import { render, staticRenderFns } from "./PackageStoreTabMenu.vue?vue&type=template&id=10ab7ccb&scoped=true"
import script from "./PackageStoreTabMenu.vue?vue&type=script&lang=js"
export * from "./PackageStoreTabMenu.vue?vue&type=script&lang=js"
import style0 from "./PackageStoreTabMenu.vue?vue&type=style&index=0&id=10ab7ccb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ab7ccb",
  null
  
)

export default component.exports